//-------- 无票收入模块 --------开始
//无票收入信息分页查询

import request, {requestbody} from './request.js'

export async function wpsr_infoPage_api(params = {

}) {
    return await requestbody('/wpsr/query', 'post', params)
}

//页面初始化
export async function wpsr_initInfo_api(params = {

}) {
    return await requestbody('/wpsr/init', 'post', params)
}
//数据来源配置分页查询
export async function wpsr_dataOriginInfoPage_api(params = {

}) {
    return await requestbody('/wpsr/dataorigin/find', 'post', params)
}
//更新取数
export async function wpsr_updateData_api(params = {

}) {
    return await requestbody('/wpsr/date/update', 'post', params)
}
//清空数据
export async function wpsr_clearNowTax_api(params = {

}) {
    return await requestbody('/wpsr/date/clear', 'post', params)
}
//修改数据来源
export async function wpsr_updateLy_api(params = {

}) {
    return await requestbody('/wpsr/dataorigin/update', 'post', params)
}
//明细登记查询
export async function wpsr_findDetails_api(params = {

}) {
    return await requestbody('/wpsr/details/query', 'post', params)
}
//获取业务格子
export async function wpsr_getYwgz_api(params = {

}) {
    return await requestbody('/wpsr/getYwgz', 'post', params)
}
//汇总填写
export async function wpsr_saveFill_api(params = {

}) {
    return await requestbody('/wpsr/fill', 'post', params)
}
//查询下拉数据
export async function wpsr_initDownload_api(params = {

}) {
    return await request('/wpsr/initDownload', 'get', params);
}
//删除明细
export async function wpsr_detailDelete_api(params = {

}) {
    return await requestbody('/wpsr/details/delete', 'post', params);
}
//无票收入明细获取编码
export async function wpsr_getbm_api(params = {

}) {
    return await requestbody('/wpsr/details/getBm', 'post', params);
}
//根据发票id获取发票明细
export async function wpsr_getfapiaomx_api(params = {

}) {
    return await request('/wpsr/details/fapiao/query', 'post', params);
}
//明细修改或新增
export async function wpsr_mxUpdateOrAdd_api(params = {

}) {
    return await requestbody('/wpsr/details/updateOrAdd', 'post', params);
}
//导入
export async function wpsr_uploadFile_api(params = {

}) {
    return await request('/wpsr/detail/import', 'post', params);
}


